<template>
  <!--b-overlay :show="loadingTips" rounded opacity="0.6" spinner-variant="primary" class="d-inline-block mr-4"-->
  <div>
    <b-card class="card-personalizada" header-tag="header" footer-tag="footer">
      <template #header>
        <div class="row">
          <div class="col-2" style="display: flex; align-items: center">
            <div class="icono">
              <img
                style="margin: auto"
                src="../../assets/images/icons/icon-money.svg"
              />
            </div>
          </div>
          <div class="col-10">
            <b class="text-center">
              <!--span class="icon icon-money mr-2 text-success"></span-->
              {{ tipsConfig.title }}
            </b>
            <h5 class="text-left">
              {{ tipsConfig.name }}
              <strong v-if="propinasGeneral.lineDeal != undefined">
                {{ propinasGeneral.lineDeal.name }}
              </strong>
              <strong v-if="propinasGeneral.pointSale != undefined">
                {{ propinasGeneral.pointSale.name }}
              </strong>
              <strong v-if="propinasGeneral.date != undefined">
                - {{ propinasGeneral.date }}
              </strong>
              {{ tipsConfig.general }}
            </h5>
          </div>
        </div>
      </template>
      <b-card-body class="pl-0">
        <span v-if="loadingTips">
          <img
            class="spinner-logo mt-2"
            src="../../assets/images/login/master_isotipo_VP.svg"
            style="margin: auto; width: 20px; height: 20px"
            alt="logo"
          />
          <span class="sr-only">Loading...</span>
        </span>
        <div class="row mt-2 line-body">
          <div class="col-7">
            <h6><b>Punto de Venta</b></h6>
            <h6>Empleados</h6>
          </div>
          <div class="col-5 text-right">
            <span class="tbl_header"
              >$ {{ propinasGeneral.employees | cero | formatPrice }}</span
            >
          </div>
        </div>
        <div
          class="row mt-2 line-body"
          v-for="supportBag in propinasGeneral.supportBags"
          v-bind:key="supportBag.name"
        >
          <div class="col-7">
            <h5><b>Bolsas de apoyo</b></h5>
            <h5>{{ supportBag.name }}</h5>
          </div>
          <div class="col-5 text-right">
            <span class="tbl_header"
              >$ {{ supportBag.value_finish | cero | formatPrice }}</span
            >
          </div>
        </div>
      </b-card-body>
      <template #footer>
        <div class="row mt-2">
          <div class="col-7">
            <h4><b>Consolidado total</b></h4>
          </div>
          <div class="col-5 text-right text-success">
            <span class="Cta" style="color: #5d5fef"
              >$ {{ propinasGeneral.valor_final | cero | formatPrice }}</span
            >
          </div>
        </div>
      </template>
    </b-card>
  </div>
  <!--/b-overlay-->
</template>

<script>
import { mapState } from "vuex";
import serverConfig from "../../services/config";
export default {
  name: "ProfitsMonth",
  filters: {
    cero: function (value) {
      if (!value) return "0";
      if (value == null) return "0";

      return value;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
    };
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modReportTips", [
      "propinasGeneral",
      "loading",
      "loadingTips",
      "tipsConfig",
    ]),
  },
  beforeMount() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
#main-menu-bar {
  width: 100%;
  background-color: #1c6776;
  border-radius: 5px 5px 0 0;
  color: #ffffff;
  position: fixed;
  z-index: 50;
  bottom: 0;
  left: 0;
  height: 50px;

  .cont-frist-icon {
    font-size: 20px;
    background-color: #ffffff;
    padding: 3px;
  }

  .cont-buttons {
    padding: 0 6px;
    .separator {
      width: 100%;
      height: 1px;
      background-color: #ffffff;
    }

    .menu-button {
      color: #ffffff;
      display: block;
      border-radius: 5px;
      padding: 15px;

      .icon {
        font-size: 24px;
      }

      p {
        font-size: 12px;
        line-height: 16px;
      }

      &:hover {
        background: #1c3a4e;
      }

      @media (min-width: 992px) {
        padding: 15px 5px;
      }
    }

    .router-link-exact-active {
      background: #1c3a4e;
    }
  }

  footer {
    background: #1c3a4e;
    border-radius: 5px;
    left: 0;
    bottom: 0;
    padding: 5px 5px;
  }
  @media (min-width: 992px) {
    width: 86px;
    height: calc(100vh - 30px);
    border-radius: 5px;
    //position: relative;
    position: sticky;
    position: -webkit-sticky;
    top: 15px;
    //position: fixed;
  }
}
.content-loader-tips {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1071;
  background-color: #fff;
  opacity: 0.9;
}

/* Center the loader */
.loader-tips {
  position: absolute;
  left: 12%;
  top: 10%;
  z-index: 1;
  width: 100px;
  height: 100px;
  margin: 0px 0 0 0px;
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #3498db;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}
.card-personalizada {
  font-family: "Ubuntu";
  font-style: normal;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  position: static;
  background: #ffffff;
  margin-top: 16px;
  border: 1px solid #eceff1 !important;
  box-sizing: border-box;
  box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
  border-radius: 12px !important;
  flex: none;
  order: 0;
  flex-grow: 0;
  width: 343px;
  border: 1px solid #c9caff;
  /* leve */

  filter: drop-shadow(0px 0px 6px rgba(110, 116, 134, 0.12));
  border-radius: 8px;

  .card-header {
    background: #ffffff;
    width: 341px;
    border-bottom: 1px solid #eceff1;
    //border-width: 90%;

    filter: drop-shadow(0px 0px 6px rgba(110, 116, 134, 0.12));
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .card-body {
    width: 95%;
    background: #ffffff;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .card-footer {
    width: 341px;
    height: 52px;
    background: #ececff;

    filter: drop-shadow(0px 0px 6px rgba(110, 116, 134, 0.12));
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .line-body {
    border-bottom: 1px solid #eceff1;
    width: 343px;
    left: 14px;
  }

  .icono {
    display: flex;
    align-items: center;

    vertical-align: middle;
    //padding: 4px;

    width: 32px;
    height: 32px;

    /* CTA/00 */

    background: #ececff;
    border-radius: 20px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
  }
}
</style>